import Form from "@/components/Form/Form";
import { TitleInput } from "@/forms/AddActivityForm/TitleInput";
import { DescriptionInput } from "@/forms/AddActivityForm/DescriptionInput";
import {
  getActivityCategoryConfig,
  type IActivityCategory,
} from "@medoma/models/activities";
import { organizationUsesInvoicingCodes } from "@medoma/models/organizations";
import { useUserProfile } from "@/api/Users";
import type { IPatientId } from "@medoma/models/patients";
import { ActivityDuration } from "@/forms/AddActivityForm/ActivityDuration";
import { AddInvoicingCodesAction } from "@/forms/AddActivityForm/AddInvoicingCodesAction";

type ActivityFieldsProps = {
  patientId: IPatientId;
  category: IActivityCategory;
  namePrefix?: string;
};

export const ActivityFields = ({
  patientId,
  category,
  namePrefix,
}: ActivityFieldsProps) => {
  return (
    <Form.Section>
      <TitleInput namePrefix={namePrefix} />
      <DescriptionInput showHelperText={false} namePrefix={namePrefix} />
      <ActivityDuration namePrefix={namePrefix} />
      <InvoicingForActivity
        patientId={patientId}
        category={category}
        namePrefix={namePrefix}
      />
    </Form.Section>
  );
};

const InvoicingForActivity = ({
  patientId,
  category,
  namePrefix,
}: {
  patientId: IPatientId;
  category: IActivityCategory;
  namePrefix?: string;
}) => {
  const { organization } = useUserProfile();
  const { allowsInvoicingCode } = getActivityCategoryConfig({
    category,
    activityHasPatient: true,
  });

  if (!allowsInvoicingCode || !organizationUsesInvoicingCodes(organization)) {
    return null;
  }

  return (
    <AddInvoicingCodesAction patientId={patientId} namePrefix={namePrefix} />
  );
};
